/* 全局reducers */
import * as globalAction from "./actions";

import {server} from "../../../common/services";

// 初始数据
const initialState = {
	init: false,
	userInfo: {},
	token: '',
	showToast: false,
	showModalEl: false,
	showLoading: false,
	modalMsg: '',
	preload: {},
	modalType: '',
	userHasLogin: false
}

// reducers
export default function reducers(state = initialState, action) {
	switch (action.type) {
		case globalAction.INIT_APP_DONE:
			return {
				...state,
				init: true
			};
		case globalAction.SAVE_PRELOAD:
			return {
				...state,
				preload: action.preload
			}
		case globalAction.LOGIN_SUCCESS:
			return {
				...state,
				token: action.token
			};
		case globalAction.SHOW_MESSAGE:
			return {
				...state,
				showToast: true,
				toastMsg: action.msg
			};
		case globalAction.HIDE_MESSAGE:
			return {
				...state,
				showToast: false
			};
		case globalAction.SHOW_LOADING:
			return {
				...state,
				showLoading: true
			};
		case globalAction.HIDE_LOADING:
			return {
				...state,
				showLoading: false
			};
		case globalAction.SHOW_MODAL:
			return {
				...state,
				modalMsg: action.msg,
				showModalEl: true
			};
		case globalAction.HIDE_MODAL:
			return {
				...state,
				showModalEl: false
			};
		case globalAction.PAY_EGIS_SUCCESS:
			return {
				...state,
				uuid: action.uuid
			};
		//eq:可删除
		case globalAction.RECEIVE_USER_INFO:
			// alert('获取用户信息了')
			return {
				...state,
				userInfo: action.userInfo,
				userHasLogin: true
			};
		case globalAction.CHANGE_USER_POINTS:
			return {
				...state,
				userInfo: {...state.userInfo, point: state.userInfo.point + action.point}
			}
		case globalAction.SHOW_CUSTOM_MODAL:
			return {
				...state,
				modalType: action.modalType
			}
		case globalAction.HIDE_CUSTOM_MODAL:
			return {
				...state,
				modalType: ''
			}
		case globalAction.GEE_DATA_RECEIVE:
			return {
				...state,
				geeData:action.data
			}
		default:
			return state
	}
}

// selectors
export function selectAppInit({app: {init}}) {
	return init
}

export function selectPreLoad({app: {preload}}) {
	return preload
}

export function selectAppUUID({app: {uuid}}) {
	return uuid
}

export function selectLoaddingState({app: {loading}}) {
	return loading
}

export function selectUserHasLogin({app: {userHasLogin}}) {
	return userHasLogin
}

export function selectGeeData({app:{geeData}}) {
	return geeData
}
